import "./utils";
import initPlanningSlider from "./swipers/planning";
import initConceptSlider from "./swipers/concept";
import initGallerySlider from "./swipers/gallery";
import initAdvantagesSlider from "./swipers/advantages";
import initPurchaseTermsSlider from "./swipers/purchase-terms";
import initConstructionProgressSlider from "./swipers/construction-progress";
import initProjectsSlider from "./swipers/projects";
import initNewsSlider from "./swipers/news";
import initBuildProgressContentSliders from "./swipers/build-progress-content";

import("./components/layout/section-index").then(({ default: initSectionIndex }) => {
  initSectionIndex();
}).catch((error) => {
  console.error("Failed to load SectionIndex module:", error);
});

import("./components/layout/smooth-scroll").catch((error) => {
  console.error("Failed to load SmoothScroll module:", error);
});

if (document.querySelector("[data-header]")) {
  import("./components/layout/header").catch((error) => {
    console.error("Failed to load Header module:", error);
  });
}

if (document.querySelector("[data-scroll-top]")) {
  import("./components/layout/scroll-to-top").catch((error) => {
    console.error("Failed to load ScrollToTop module:", error);
  });
}

if (document.querySelector("[data-faq]")) {
  import("./components/faq").then(({ default: initFaqSections }) => {
    initFaqSections();
  }).catch((error) => {
    console.error("Failed to load FAQ module:", error);
  });
}

if (document.querySelector(".swiper")) {
  import("./swipers/main").catch((error) => {
    console.error("Failed to load Swiper module:", error);
  });
}

if (document.querySelector(".concept__slider")) {
  initConceptSlider();
}
if (document.querySelector(".gallery__slider")) {
  initGallerySlider();
}
if (document.querySelector(".advantages__carousel")) {
  initAdvantagesSlider();
}
if (document.querySelector(".purchase-terms__slider")) {
  initPurchaseTermsSlider();
}
if (document.querySelector(".planning__slider")) {
  initPlanningSlider();
}
if (document.querySelector(".construction-progress__slider")) {
  initConstructionProgressSlider();
}
if (document.querySelector(".projects__slider")) {
  initProjectsSlider();
}
if (document.querySelector(".news__slider")) {
  initNewsSlider();
}
if (document.querySelector("[data-build-progress-content]")) {
  initBuildProgressContentSliders();
}

if (document.querySelector("[data-video-report]")) {
  import("./components/build-progress/video-report").then(({ default: initBuildProgressVideoReports }) => {
    initBuildProgressVideoReports();
  }).catch((error) => {
    console.error("Failed to load build progress video report:", error);
  });
}
if (document.querySelector("[data-news-share]")) {
  import("./components/news/share").then(({ default: initNewsShare }) => {
    initNewsShare();
  }).catch((error) => {
    console.error("Failed to load news share module:", error);
  });
}
if (document.querySelector("[data-news-load-more]")) {
  import("./components/news/load-more").then(({ default: initNewsLoadMore }) => {
    initNewsLoadMore();
  }).catch((error) => {
    console.error("Failed to load news load-more module:", error);
  });
}
if (document.querySelector("[data-privacy-read-more]")) {
  import("./components/privacy/main").then(({ default: initPrivacyReadMore }) => {
    initPrivacyReadMore();
  }).catch((error) => {
    console.error("Failed to load privacy read-more module:", error);
  });
}
const contactMapElements = Array.from(document.querySelectorAll("[data-contact-map]"));

if (contactMapElements.length > 0) {
  let contactMapObserver = null;
  let isContactMapLoading = false;

  const loadContactMaps = () => {
    if (isContactMapLoading) return;

    isContactMapLoading = true;
    contactMapObserver?.disconnect();

    import("./components/contacts/map").then(({ default: initContactMaps }) => {
      initContactMaps();
    }).catch((error) => {
      console.error("Failed to load contact maps:", error);
    });
  };

  if ("IntersectionObserver" in window) {
    contactMapObserver = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        loadContactMaps();
      }
    }, {
      rootMargin: "400px 0px",
    });

    contactMapElements.forEach((element) => contactMapObserver.observe(element));
  } else {
    loadContactMaps();
  }
}
if (document.querySelector(".backdrop, .js-mobile-menu-popup")) {
  import("./popups/main").catch((error) => {
    console.error("Failed to load Popups module:", error);
  });
}

import "../css/main.scss";
